import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey,
  getGetApiV1ThreeLetterCodePartnerAdminsContractPlansUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlans200 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';

type MutationArg = {
  /** 契約プラン名（部分一致検索） */
  name?: string;
  /** ページ番号（1 始まり） */
  page: number;
};

type Options = {
  onSuccess?: (
    res: ResponseWithHeaders<GetApiV1ThreeLetterCodePartnerAdminsContractPlans200>
  ) => void;
  onError?: (error: Error) => void;
};

/**
 * 契約プラン一覧の任意発火 GET フック
 *
 * PaginatedSelectController の searchAction は「ボタン操作・スクロール操作のたびに 1 回だけ実行」
 * する命令的 I/F のため、自動発火の useFetch ではなく useMutation でラップする。
 * レスポンスヘッダーから total-pages を取得するため customInstanceWithHeader を使用。
 *
 * @param threeLetterCode - パートナーの 3 文字コード
 * @param options - 成功時 / 失敗時コールバック（任意）
 */
export const useGetPartnerAdminsContractPlansMutation = (
  threeLetterCode: string,
  options?: Options
) =>
  useMutation(
    getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey(threeLetterCode),
    (_key, { arg }: { arg: MutationArg }) =>
      customInstanceWithHeader<GetApiV1ThreeLetterCodePartnerAdminsContractPlans200>(
        getGetApiV1ThreeLetterCodePartnerAdminsContractPlansUrl(threeLetterCode, {
          name: arg.name,
          page: arg.page,
        }),
        { method: 'GET' }
      ),
    options
  );
